import { ActionTypes } from "../constants/actionTypes";

const initialState = {
    applications: { data: null, requestInProgress: false, error: null },
    primaries: { data: null, requestInProgress: false, error: null },
    secondaries: { data: null, requestInProgress: false, error: null },
};

export function storageApplication(state = initialState, action) {
    switch (action.type) {
        case ActionTypes.STORAGE_APPLICATIONS_REQUEST:
            return { ...state, applications: { requestInProgress: true } };
        case ActionTypes.STORAGE_APPLICATIONS_SUCCESS:
            return { ...state, applications: { data: action.applications, requestInProgress: false } };
        case ActionTypes.STORAGE_APPLICATIONS_FAILURE:
            return { ...state, applications: { requestInProgress: false, error: action.error } };
        case ActionTypes.APPLICATION_PRIMARY_REQUEST:
            return { ...state, primaries: { requestInProgress: true } };
        case ActionTypes.APPLICATION_PRIMARY_SUCCESS:
            return { ...state, primaries: { data: action.primaries, requestInProgress: false } };
        case ActionTypes.APPLICATION_PRIMARY_FAILURE:
            return { ...state, primaries: { requestInProgress: false, error: action.error } }
        case ActionTypes.APPLICATION_SECONDARY_REQUEST:
            return { ...state, secondaries: { requestInProgress: true } };
        case ActionTypes.APPLICATION_SECONDARY_SUCCESS:
            return { ...state, secondaries: { data: action.secondaries, requestInProgress: false } };
        case ActionTypes.APPLICATION_SECONDARY_FAILURE:
            return { ...state, secondaries: { requestInProgress: false, error: action.error } };
        default:
            return state;
    }
}